import { Stringing, Person, StringType } from "../types"
import CreateStringingForm from "./CreateStringingForm"
import { useEffect, useState } from "react";
import {
  getAllPersons,
  getAllRacquets,
  getAllStringTypes,
} from '../api';
import ResponsiveDialog from "./ResponsiveDialog";
import { Box, Typography } from '@mui/material';

type Props = {
  selectedStringing: Stringing
  closeForm: () => void
}

export default function EditStringingForm(props: Props) {
  const { closeForm, selectedStringing } = props

  async function fetchData() {
    const [p, s] = await Promise.all([
      getAllPersons(),
      getAllStringTypes(),
      getAllRacquets(),
    ]);
    setPersons(p);
    setStringTypes(s);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const [persons, setPersons] = useState<Person[]>([]);
  const [stringTypes, setStringTypes] = useState<StringType[]>([]);


  return (
    <ResponsiveDialog open onClose={() => closeForm()} maxWidth="sm">
      <CreateStringingForm
        stringing={selectedStringing}
        persons={persons}
        stringTypes={stringTypes}
        onSave={closeForm}
        onCancel={closeForm}
        title="Edit Stringing"
      />
    </ResponsiveDialog>

  )
};